<template>
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions vuejs-accessibility/click-events-have-key-events -->
    <div
        v-if="data != null"
        ref="productListingTeaserEl"
        class="w-full h-full relative flex"
        tabindex="0"
        :style="teaserStyle"
        @click="onElClick($event)"
    >
        <MiscImage
            v-if="media != null && !isVideo"
            :src="media?.path"
            width="345"
            height="460"
            fit="fit"
            sizes="268px sm:208px md:223px lg:294px xl:262px 2xl:345px"
            :alt="media?.alt"
            lazy-load
            class="absolute top-0 left-0 w-full h-full object-cover"
        />

        <MiscVideo
            v-if="media != null && isVideo"
            :src="`${media?.url}#t=0.1`"
            preload="none"
            autoplay
            muted
            loop
            class="w-full h-auto object-cover"
            :alt="media.alt"
        />

        <div
            v-if="hasContent(data.title) || hasContent(data.buttonText)"
            class="absolute w-full h-full top-0 left-0 z-10"
            style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.65) 100%); background-blend-mode: multiply;"
        />

        <div
            v-if="hasContent(data.title) || hasContent(data.buttonText)"
            class="w-full p-6 mt-auto flex flex-col gap-6 z-10"
            :class="{'absolute bottom-0' : isVideo}"
        >
            <div v-if="data.title != null" class="text-center font-fjalla-one uppercase text-base-100 text-2xl lg:text-6xl">
                {{ data.title }}
            </div>

            <MiscLink
                v-if="data.url != null && data.buttonText != null"
                :to="data.url"
                class="btn w-full"
                :class="buttonTheme"
                @click="handleScrollAndClick($event, data.url)"
            >
                {{ data.buttonText }}
            </MiscLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import { handleScrollAndClick } from '@/utils/handle-scroll-and-click'

const props = defineProps<{
    data: Schemas['A4gProductListingTeaser']
    useSwiperHeight?: number,
    index?: number
}>()

const media = computed(() => props.data?.translated?.media ?? null)

const isVideo = computed(() => {
    return media.value?.fileExtension === 'mp4' || media.value?.fileExtension === 'mov'
})

const buttonTheme = computed(() => {
    return props.data?.buttonTheme ? `btn-${props.data.buttonTheme}` : ''
})

const swiperHeight = computed(() => props.useSwiperHeight)
const teaserStyle = computed(() => {
    return swiperHeight.value ? `height:${swiperHeight.value}px;` : ''
})

const productListingTeaserEl = ref<HTMLDivElement | null>(null)
const trackingData: Schemas['PromotionData'] | undefined = props.data?.promotion
const { selectPromotion, computedPromotionData } = usePromotionObserver(
    productListingTeaserEl,
    trackingData
)

function onElClick (event: MouseEvent) {
    if (computedPromotionData?.value) selectPromotion(computedPromotionData.value, event)
}

function hasContent (input: string | null) {
    return (input != null && input.trim() != '')
}
</script>
